import { Theme } from '../../design_system';

export interface ThemingState {
  theme: Theme;
}

export const themeKey = 'sap.build.apps.theme';
